import type { UserListItem } from '../entities/user.entity'
import type { ListUsersParams, UserRepository } from '../repositories/user_repository'

export class GetUsersUseCase {
  constructor(private readonly repository: UserRepository) {}

  execute(params: ListUsersParams): Promise<UserListItem[]> {
    return this.repository.list(params)
  }
}
